module.exports = __webpack_public_path__ + "static/media/news.1d926d9e.svg";